import { Injectable } from '@angular/core';
import { AssessmentQuestionBase } from './models/assessment-question-base.model';
import { TextEntryQuestion } from './models/question-textentry.model';
import { SingleChoiceQuestion } from './models/question-single-choice.model';

@Injectable()
export class AssessmentFormService {
  constructor(
  ) { }

  buildQuestions(fields?: any): AssessmentQuestionBase<any>[] {
    debugger;
    let questions = [];
    return questions = fields.map((field) => {
      let question: any = {};
      switch (field['type']) {
        case 'text-entry-question':
          question = new TextEntryQuestion({
            key: field['name'],
            label: field['question_text'],
            textEntrytype: field['textEntrytype'],
            calculated_field: field['calculated_field'],
            calculation_formula: field['calculation_formula'],
            select_defination: field['select_defination'],
            required: field['required'],
            visible: field['visible']
          });
          break;
        case 'single-choice-question':
          question = new SingleChoiceQuestion({
            key: field['name'],
            label: field['question_text'],
            singleChoicetype: field['singleChoicetype'],
            options: field['questionOpionField'],
            required: field['required'],
            visible: field['visible']
          });
          break;
      }
      return question;
    });
  }
}


